import { render, staticRenderFns } from "./Jonathan.vue?vue&type=template&id=52968c50&scoped=true&"
import script from "./Jonathan.vue?vue&type=script&lang=js&"
export * from "./Jonathan.vue?vue&type=script&lang=js&"
import style0 from "./Jonathan.vue?vue&type=style&index=0&id=52968c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52968c50",
  null
  
)

export default component.exports